import { lazy, Suspense, useEffect, useMemo, useState } from 'react';
import {
  Authenticator,
  View,
  Button,
  Divider,
  Flex,
  useAuthenticator
} from '@aws-amplify/ui-react';
import awsmobile from './aws-exports';
import { Amplify, Auth } from 'aws-amplify';
import { I18n } from 'aws-amplify';
// COMPONENTS
import Logo from './assets/logo_maketheway_vetorizado.png';
import LogoETZ from './assets/eTz_Coloured.png';
import LogoLevdata from './assets/logo_levdata.png';
import LogoLevdataIcone from './assets/logo_levdata_icone.png';
import LogoNavTax from './assets/logo_navtax.png';
import LoadingAnimation from 'components/MTWFeedback/Loading';
import ErrorBoundary from 'components/ErrorBoundary';
// QuickSight dashboard feature disabled
// import MakeBILauncher from 'project/make-bi/pages/MakeBILauncher';
// import QSearchBar from 'project/make-bi/pages/QSearchHome';
// import DashboardEmbeddedHome from './project/dashboard-embedded/pages/DashboardEmbeddedHome';

// REACT ROUTER
import { Route, Routes, useLocation } from 'react-router-dom';
import { DLMWORKFLOWS, DLMUSERMANAGEMENT, MAKEREFORMA } from 'Routes';
// REACT LAZY
const WelcomeSection = lazy(() =>
  import('./project/portal/pages/WelcomeSection')
);
const Cat42 = lazy(() => import('./project/make-the-price'));
const Elementar = lazy(() => import('./project/elementar'));
const CadastrosBasicos = lazy(() => import('./project/cadastros-basicos'));
const NotaAvulsa = lazy(() => import('./project/make-forward'));
const MakeForwardNfse = lazy(() => import('./project/make-forward-nfse'));
const MakeForwardCte = lazy(() => import('./project/make-forward-cte'));
const MakeForwardNfcom = lazy(() => import('./project/make-forward-nfcom'));
const SubidaDeDocumentos = lazy(() => import('./project/upload'));
const SubidaDeDocumentosDE = lazy(() => import('./project/upload-de'));
const SubidaDeDocumentosCCS = lazy(() => import('./project/upload-ccs'));
const UploadCcsTablePage = lazy(() =>
  import('./project/upload-ccs-table/pages')
);
const SubidaDeDocumentosMakeView = lazy(() =>
  import('./project/make-view-upload')
);
const SolicitarDocumentos = lazy(() =>
  import('./project/solicitar-documentos')
);
const BaseLegal = lazy(() => import('./project/base-legal'));
const DefinirCategorias = lazy(() => import('./project/definir-categorias'));
const MakeView = lazy(() => import('./project/make-view'));
const MakeViewFiles = lazy(() => import('./project/make-view-files'));
const IntegrationsManagement = lazy(() =>
  import('./project/make-forward-integrations')
);
const MTWHiddenPage = lazy(() => import('./project/hidden-page'));
const Reports = lazy(() => import('./project/reports'));
const NcmSelector = lazy(() => import('./project/ncm-selector'));
const Page404 = lazy(() => import('./project/page-not-found'));
const HealthCheck = lazy(() => import('./project/health-check'));
const TaxInformation = lazy(() => import('./project/tax-information-page'));
const LifeCycle = lazy(() => import('./project/document-lifecycle'));
const DlmWorkflow = lazy(() => import('./project/dlm-workflows'));
const DlmUserManagement = lazy(() => import('./project/dlm-user-management'));
const Diagrams = lazy(() => import('./components/JointJSWorkflow'));
const TaxMatrix = lazy(() => import('./project/tax-matrix'));
const Declaracoes = lazy(() => import('./project/declaracoes'));
const MakeReforma = lazy(() => import('./project/make-reforma'));
const GestaoFinanceira = lazy(() => import('./project/gestao-financeira'));
const Dashboards = lazy(() => import('./project/dashboards-levdata'));
const TaxCredits = lazy(() =>
  import('./project/dashboards-levdata/TaxCredits')
);
const TaxPlanning = lazy(() =>
  import('./project/dashboards-levdata/TaxPlanning')
);
const RegimeComparison = lazy(() =>
  import('./project/dashboards-levdata/RegimeComparison')
);
const Pricing = lazy(() => import('./project/dashboards-levdata/Pricing'));
const TaxRegimeSimulation = lazy(() =>
  import('./project/dashboards-levdata/TaxRegimeSimulation')
);
const IntelligenceEngine = lazy(() =>
  import('./project/dashboards-levdata/IntelligenceEngine')
);
const FinancialSummary = lazy(() =>
  import('./project/dashboards-levdata/FinancialSummary')
);
const CashFlow = lazy(() => import('./project/dashboards-levdata/CashFlow'));
const Reconciliation = lazy(() =>
  import('./project/dashboards-levdata/Reconciliation')
);
const FluxoGitTarefas = lazy(() =>
  import('./project/relatorio/FluxoGitTarefas')
);
const SelecaoProduto = lazy(() =>
  import('./project/dashboards-levdata/SelecaoProduto')
);
const SelecaoServico = lazy(() =>
  import('./project/dashboards-levdata/SelecaoServico')
);
const ReconciliationDashboard = lazy(() =>
  import('./project/etz/ReconciliationDashboard')
);
// const MakeDashbourdEmbedded = lazy(() =>
//   import('./project/dashboard-embedded')
// );
// REDUX
import {
  recordUserCurrentLanguage,
  recordETZSession,
  userdataSelector
} from 'features/userFeatures/userdata.store';
import { useDispatch, useSelector } from 'react-redux';
// SERVICES
import { ToastContainer } from 'react-toastify';
import { portalTitles } from './services/portalTitles';
// import { makeViewBranches } from './consts/makeView';
// STYLE
import { ThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { IconContainer } from './styledComponentsStyles';
import { applyBrandPalette } from './theme';
import { applyBrandPalette as applyStyledBrandPalette } from './styledThemeOn';
import '@aws-amplify/ui-react/styles.css';

I18n.putVocabularies({
  'pt-BR': {
    'Sign in': 'Entrar',
    'Sign In': 'Entrar',
    'Signing in': 'Entrando...',
    'Sign Up': 'Cadastrar',
    // eslint-disable-next-line
    Email: 'Email',
    // eslint-disable-next-line
    Password: 'Senha',
    'Forgot your password?': 'Esqueceu sua senha?',
    'Reset Password': 'Redefinir Senha',
    // eslint-disable-next-line
    Submit: 'Enviar',
    'Send Code': 'Enviar Código',
    'Back to Sign In': 'Voltar para o Login',
    // eslint-disable-next-line
    Confirm: 'Confirmar',
    'New Password': 'Nova Senha',
    'Confirm Password': 'Confirmar Senha',
    'Change Password': 'Alterar Senha',
    Verify: 'Verificar',
    Skip: 'Pular'
  }
});

I18n.setLanguage('pt-BR');

Amplify.configure(awsmobile);

function App() {
  const { userCurrentLanguage } = useSelector(userdataSelector);
  const [locationChecked, setLocationChecked] = useState(false);

  let fullUrl;

  try {
    fullUrl = useLocation();
  } catch {
    if (window.location.pathname) {
      fullUrl = { pathname: window.location.pathname };
      fullUrl = '';
    }
  }

  const dispatch = useDispatch();

  // Roxo é a marca MTW - numa rota /levdata ele não pode aparecer em
  // NENHUMA tela do Portal, nem nas que reusam componentes compartilhados
  // com o resto do app (o Button padrão, campos do MUI etc.), não só no
  // menu. Em vez de caçar cada cor roxa fixa tela por tela, troca-se a
  // paleta "primary"/"accentPurple" dos dois temas compartilhados (MUI e
  // styled-components) pela Navy/Coral da LevData a cada navegação -
  // `applyBrandPalette` muta o tema compartilhado (alcança quem importa
  // `theme`/`styledtheme` direto) e devolve um clone (referência nova, pro
  // Context do MUI propagar a troca pra quem usa `color="primary"`/
  // `useTheme()` nativos). O mesmo efeito abaixo troca um atributo no
  // <html> pro lado CSS puro (arquivos .css, que não enxergam o tema em
  // JS) - ver src/styles/tokens.css. Componentes/CSS que ainda leem um hex
  // roxo fixo em vez de referenciar o tema/as variáveis continuam fora do
  // alcance disso - foram corrigidos um a um (ver histórico de commits),
  // mas qualquer código novo deve usar `theme.palette.primary`/
  // `var(--color-brand)`, nunca `#A646DC` direto.
  const isLevdataRoute = Boolean(fullUrl?.pathname?.startsWith('/levdata'));
  const activeTheme = useMemo(
    () => applyBrandPalette(isLevdataRoute),
    [isLevdataRoute]
  );
  const activeStyledTheme = useMemo(
    () => applyStyledBrandPalette(isLevdataRoute),
    [isLevdataRoute]
  );

  // Mesma troca de marca acima, só que pro lado CSS puro (arquivos .css,
  // que não têm como ler o tema em JS) - troca um atributo no <html>, e
  // src/styles/tokens.css redefine as variáveis --color-brand-* dentro do
  // bloco [data-brand="levdata"]. Já fica pronto pra um futuro modo escuro
  // no mesmo padrão (um data-theme="dark" + um novo bloco em tokens.css).
  useEffect(() => {
    document.documentElement.setAttribute(
      'data-brand',
      isLevdataRoute ? 'levdata' : 'mtw'
    );
  }, [isLevdataRoute]);

  // Título e favicon da aba do navegador seguem a mesma marca - numa rota
  // /levdata a aba mostra só "LevData" + o ícone da LevData, sem nenhum
  // traço da MTW; fora dela, volta pro título/ícone padrão da MTW.
  useEffect(() => {
    document.title = isLevdataRoute ? 'LevData' : 'Make The Future';

    let favicon = document.querySelector("link[rel='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    // eslint-disable-next-line no-undef
    const mtwFaviconUrl = `${process.env.PUBLIC_URL}/Logo-MakeTheWay.ico`;
    favicon.href = isLevdataRoute ? LogoLevdataIcone : mtwFaviconUrl;
  }, [isLevdataRoute]);

  const DefaultFooter = () => {
    const { toForgotPassword } = useAuthenticator();
    return (
      <View data-amplify-footer="">
        <Button onClick={toForgotPassword} size="small" variation="link">
          {portalTitles[userCurrentLanguage].forgotPassword}
        </Button>
      </View>
    );
  };

  // Logo do login: a rota manda (Make the Way e LevData são empresas
  // distintas - LevData só em /levdata). Só na raiz "/" (para onde o logout
  // volta) vale a última plataforma visitada, guardada no navegador.
  const caminhoDoLogin = fullUrl?.pathname || window.location.pathname || '/';
  const loginNaRaiz = caminhoDoLogin === '/' || caminhoDoLogin === '';
  const ultimaPlataforma = (chave) =>
    loginNaRaiz && localStorage.getItem(chave) === 'true';
  const isETZ =
    caminhoDoLogin.startsWith('/etz') || ultimaPlataforma('isMTWFromETZ');
  const isLevdata =
    !isETZ &&
    (caminhoDoLogin.startsWith('/levdata') ||
      ultimaPlataforma('isMTWFromLevdata'));
  const isNavTax =
    !isETZ &&
    !isLevdata &&
    (caminhoDoLogin.startsWith('/navtax') ||
      ultimaPlataforma('isMTWFromNavTax'));

  const customComponents = {
    SignIn: {
      Header() {
        return (
          <View textAlign="center" padding={'34px 0px 6px 0px'}>
            <img
              alt={
                isETZ
                  ? 'ETZ'
                  : isLevdata
                  ? 'LevData'
                  : isNavTax
                  ? 'NavTax'
                  : 'Make the Way'
              }
              src={
                isETZ
                  ? LogoETZ
                  : isLevdata
                  ? LogoLevdata
                  : isNavTax
                  ? LogoNavTax
                  : Logo
              }
              height={isETZ ? 80 : isLevdata ? 48 : isNavTax ? 70 : 48}
            />
          </View>
        );
      },
      Footer() {
        return (
          <Flex direction="column" className="federated-sign-in-container">
            <DefaultFooter />
            <Divider label={portalTitles[userCurrentLanguage].orWord} />
            <View paddingLeft="30px" paddingRight="30px" paddingBottom="20px">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '6px 0px 4px 0px'
                }}
              >
                <Button
                  onClick={() =>
                    Auth.federatedSignIn({ provider: 'MundialAzure' })
                  }
                >
                  {portalTitles[userCurrentLanguage].signInAzure}
                </Button>
              </div>
            </View>
          </Flex>
        );
      }
    }
  };

  useEffect(() => {
    if (!fullUrl?.pathname) return;

    if (fullUrl.pathname.startsWith('/etz')) {
      I18n.setLanguage('en');
      dispatch(recordUserCurrentLanguage('EN'));
      dispatch(recordETZSession(true));
      localStorage.setItem('isMTWFromETZ', true);
      localStorage.setItem('isMTWFromLevdata', false);
      localStorage.setItem('isMTWFromNavTax', false);
    }

    if (fullUrl.pathname.startsWith('/etz/leave')) {
      localStorage.setItem('isMTWFromETZ', false);
      window.location.href = 'https://makethefuture.tech/';
    }

    if (fullUrl.pathname.startsWith('/levdata')) {
      I18n.setLanguage('pt-BR');
      dispatch(recordUserCurrentLanguage('PT'));
      localStorage.setItem('isMTWFromETZ', false);
      localStorage.setItem('isMTWFromLevdata', true);
      localStorage.setItem('isMTWFromNavTax', false);
    }

    if (fullUrl.pathname.startsWith('/levdata/leave')) {
      localStorage.setItem('isMTWFromLevdata', false);
      window.location.href = 'https://makethefuture.tech/';
    }

    if (fullUrl.pathname.startsWith('/navtax')) {
      I18n.setLanguage('pt-BR');
      dispatch(recordUserCurrentLanguage('PT'));
      localStorage.setItem('isMTWFromETZ', false);
      localStorage.setItem('isMTWFromLevdata', false);
      localStorage.setItem('isMTWFromNavTax', true);
    }

    if (fullUrl.pathname.startsWith('/navtax/leave')) {
      localStorage.setItem('isMTWFromNavTax', false);
      window.location.href = 'https://makethefuture.tech/';
    }

    setLocationChecked(true);
  }, [fullUrl]);

  useEffect(() => {
    if (localStorage.getItem('isMTWFromETZ') == 'true') {
      dispatch(recordUserCurrentLanguage('EN'));
    }
  }, [localStorage]);

  return (
    <>
      {locationChecked ? (
        <Authenticator components={customComponents}>
          {({ signOut, user }) => (
            <MuiThemeProvider theme={activeTheme}>
              <ThemeProvider theme={activeStyledTheme}>
                <ErrorBoundary>
                  <Suspense
                    fallback={
                      <IconContainer>
                        <LoadingAnimation />
                      </IconContainer>
                    }
                  >
                    <Routes>
                      <Route index element={<WelcomeSection />} />
                      <Route path="/etz" element={<WelcomeSection />} />
                      <Route path="/levdata" element={<WelcomeSection />} />
                      <Route path="/navtax" element={<WelcomeSection />} />
                      <Route path="/" element={<WelcomeSection />} />
                      {/* QuickSight dashboard routes disabled
                      <Route
                        path={MAKEBI}
                        element={
                          <MakeBILauncher
                            branch={makeViewBranches.MAKEVIEWDASHBOARDS}
                          />
                        }
                      />
                      <Route
                        path={MAKEFORWARDDASHBOARDS}
                        element={
                          <MakeBILauncher
                            branch={makeViewBranches.MAKEFORWARDDASHBOARDS}
                          />
                        }
                      />
                      <Route
                        path="levdata/make-forward/dashboards"
                        element={
                          <MakeBILauncher
                            branch={makeViewBranches.MAKEFORWARDDASHBOARDS}
                          />
                        }
                      />
                      <Route
                        path="navtax/make-forward/dashboards"
                        element={
                          <MakeBILauncher
                            branch={makeViewBranches.MAKEFORWARDDASHBOARDS}
                          />
                        }
                      />
                      <Route
                        path={REFORMA}
                        element={
                          <MakeBILauncher
                            branch={makeViewBranches.REFORMADASHBOARDS}
                          />
                        }
                      />
                      <Route
                        path="/levdata/make-view"
                        element={
                          <MakeBILauncher
                            branch={makeViewBranches.MAKEVIEWDASHBOARDS}
                          />
                        }
                      />
                      <Route
                        path="/navtax/make-view"
                        element={
                          <MakeBILauncher
                            branch={makeViewBranches.MAKEVIEWDASHBOARDS}
                          />
                        }
                      />
                      <Route
                        path="/navtax/Reforma"
                        element={
                          <MakeBILauncher
                            branch={makeViewBranches.REFORMADASHBOARDS}
                          />
                        }
                      />
                      <Route
                        path={CREDITOS}
                        element={
                          <MakeBILauncher
                            branch={makeViewBranches.CREDITOSDASHBOARDS}
                          />
                        }
                      />
                      <Route
                        path="navtax/creditos"
                        element={
                          <MakeBILauncher
                            branch={makeViewBranches.CREDITOSDASHBOARDS}
                          />
                        }
                      />
                      <Route
                        path="levdata/creditos"
                        element={
                          <MakeBILauncher
                            branch={makeViewBranches.CREDITOSDASHBOARDS}
                          />
                        }
                      />
                      <Route path={QSEARCHBAR} element={<QSearchBar />} />
                      */}
                      <Route path="cat42/home/*" element={<Cat42 />} />
                      <Route
                        path="make-the-price/home/*"
                        element={<Elementar />}
                      />
                      <Route
                        path="/levdata/make-the-price/home/*"
                        element={<Elementar />}
                      />
                      <Route
                        path="/navtax/make-the-price/home/*"
                        element={<Elementar />}
                      />
                      <Route path="/declaracoes/*" element={<Declaracoes />} />
                      <Route
                        path={`${MAKEREFORMA}/*`}
                        element={<MakeReforma />}
                      />
                      <Route
                        path="/levdata/declaracoes*"
                        element={<Declaracoes />}
                      />
                      <Route
                        path="/navtax/declaracoes*"
                        element={<Declaracoes />}
                      />
                      <Route
                        path="cadastros-basicos/home/*"
                        element={<CadastrosBasicos />}
                      />
                      <Route
                        path="/levdata/cadastros-basicos/home/*"
                        element={<CadastrosBasicos />}
                      />
                      <Route path="/make-forward/*" element={<NotaAvulsa />} />
                      <Route
                        path="/levdata/make-forward*"
                        element={<NotaAvulsa />}
                      />
                      <Route
                        path="/navtax/make-forward*"
                        element={<NotaAvulsa />}
                      />
                      <Route
                        path="/make-forward-nfse*"
                        element={<MakeForwardNfse />}
                      />
                      <Route
                        path="/levdata/make-forward-nfse*"
                        element={<MakeForwardNfse />}
                      />
                      <Route
                        path="/navtax/make-forward-nfse*"
                        element={<MakeForwardNfse />}
                      />
                      <Route
                        path="/make-forward-cte*"
                        element={<MakeForwardCte />}
                      />
                      <Route
                        path="/levdata/make-forward-cte*"
                        element={<MakeForwardCte />}
                      />
                      <Route
                        path="/navtax/make-forward-cte*"
                        element={<MakeForwardCte />}
                      />
                      <Route
                        path="/make-forward-nfcom*"
                        element={<MakeForwardNfcom />}
                      />
                      <Route
                        path="/levdata/make-forward-nfcom*"
                        element={<MakeForwardNfcom />}
                      />
                      <Route
                        path="/navtax/make-forward-nfcom*"
                        element={<MakeForwardNfcom />}
                      />
                      <Route
                        path="/subida-documentos*"
                        element={<SubidaDeDocumentos />}
                      />
                      <Route
                        path="/levdata/subida-documentos*"
                        element={<SubidaDeDocumentos />}
                      />
                      <Route
                        path="/navtax/subida-documentos*"
                        element={<SubidaDeDocumentos />}
                      />
                      <Route
                        path="/upload-documents-de*"
                        element={<SubidaDeDocumentosDE />}
                      />
                      <Route
                        path="/etz/reconciliation*"
                        element={<SubidaDeDocumentosCCS />}
                      />
                      <Route
                        path="/reconciliation-table*"
                        element={<UploadCcsTablePage />}
                      />
                      <Route
                        path="/solicitar-documentos*"
                        element={<SolicitarDocumentos />}
                      />
                      <Route
                        path="/levdata/solicitar-documentos*"
                        element={<SolicitarDocumentos />}
                      />
                      <Route
                        path="/navtax/solicitar-documentos*"
                        element={<SolicitarDocumentos />}
                      />
                      <Route path="/base-legal*" element={<BaseLegal />} />
                      {/* <Route
                      path="/levdata/base-legal*"
                      element={<BaseLegal />}
                    /> */}
                      <Route
                        path="/navtax/base-legal*"
                        element={<BaseLegal />}
                      />
                      <Route
                        path="/definir-categorias*"
                        element={<DefinirCategorias />}
                      />
                      <Route path="/make-view*" element={<MakeView />} />
                      <Route
                        path="/subida-documentos-make-view*"
                        element={<SubidaDeDocumentosMakeView />}
                      />
                      <Route path="/files*" element={<MakeViewFiles />} />
                      <Route
                        path="/levdata/files*"
                        element={<MakeViewFiles />}
                      />
                      <Route
                        path="/navtax/files*"
                        element={<MakeViewFiles />}
                      />
                      <Route
                        path="/integrations-management*"
                        element={<IntegrationsManagement />}
                      />
                      <Route
                        path="/mtw-hidden-page*"
                        element={<MTWHiddenPage />}
                      />
                      <Route path="/reports*" element={<Reports />} />
                      <Route path="/ncm-selector*" element={<NcmSelector />} />
                      <Route path="*" element={<Page404 />} />
                      <Route path="/health-check*" element={<HealthCheck />} />
                      <Route
                        path="/tax-information-page*"
                        element={<TaxInformation />}
                      />
                      <Route path="/etz/dlm*" element={<LifeCycle />} />
                      <Route path="/dlm*" element={<LifeCycle />} />
                      <Route path={DLMWORKFLOWS} element={<DlmWorkflow />} />
                      <Route path="/diagrams*" element={<Diagrams />} />
                      <Route
                        path={DLMUSERMANAGEMENT}
                        element={<DlmUserManagement />}
                      />
                      <Route
                        path="/make-the-price/home/embasamento-legal*"
                        element={<TaxMatrix />}
                      />
                      <Route
                        path="/levdata/make-the-price/home/embasamento-legal*"
                        element={<TaxMatrix />}
                      />
                      <Route
                        path="/navtax/make-the-price/home/embasamento-legal*"
                        element={<TaxMatrix />}
                      />
                      <Route
                        path="/levdata/financeiro/*"
                        element={<GestaoFinanceira />}
                      />
                      {/* QuickSight dashboard route disabled
                      <Route
                        path={'/make-dashboard-embedded'}
                        element={<DashboardEmbeddedHome />}
                      />
                      */}
                      <Route
                        path="/levdata/dashboards/*"
                        element={<Dashboards />}
                      />
                      <Route
                        path="/levdata/tax-regime-simulation/*"
                        element={<TaxRegimeSimulation />}
                      />
                      <Route
                        path="/levdata/tax-credits/*"
                        element={<TaxCredits />}
                      />
                      <Route
                        path="/levdata/regime-comparison/*"
                        element={<RegimeComparison />}
                      />
                      <Route
                        path="/levdata/tax-planning/*"
                        element={<TaxPlanning />}
                      />
                      <Route path="/levdata/pricing/*" element={<Pricing />} />
                      <Route
                        path="/levdata/intelligence-engine/*"
                        element={<IntelligenceEngine />}
                      />
                      <Route
                        path="/levdata/financial-summary/*"
                        element={<FinancialSummary />}
                      />
                      <Route
                        path="/levdata/cash-flow/*"
                        element={<CashFlow />}
                      />
                      <Route
                        path="/levdata/reconciliation/*"
                        element={<Reconciliation />}
                      />
                      <Route
                        path="/relatorio/novo_fluxo_git_banco/tarefas"
                        element={<FluxoGitTarefas />}
                      />
                      <Route
                        path="/levdata/selecao-produto/*"
                        element={<SelecaoProduto />}
                      />
                      <Route
                        path="/levdata/selecao-servico/*"
                        element={<SelecaoServico />}
                      />
                      <Route
                        path="/etz/reconciliation-dashboard/*"
                        element={<ReconciliationDashboard />}
                      />
                    </Routes>
                    <div style={{ display: 'none' }}>
                      <h3>Welcome, {user?.attributes?.email}</h3>
                      <button onClick={signOut}>Sign-out</button>
                    </div>
                  </Suspense>
                </ErrorBoundary>
              </ThemeProvider>
            </MuiThemeProvider>
          )}
        </Authenticator>
      ) : null}
      <ToastContainer theme="colored" />
    </>
  );
}

export default App;
